import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-img",
  "use": "icon-img-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-img\"><path d=\"M512 0C229.229 0 0 229.23 0 512s229.229 512 512 512c282.77 0 512-229.23 512-512S794.77 0 512 0z m0 972.8C257.505 972.8 51.2 766.495 51.2 512S257.505 51.2 512 51.2c254.5 0 460.8 206.305 460.8 460.8S766.5 972.8 512 972.8z m382.729-222.23H129.27l169.25-260.045 120.141 184.59L632.814 336.81l261.915 413.76zM336.92 293.565c0 21.205-17.19 38.4-38.4 38.4-21.205 0-38.399-17.195-38.399-38.4s17.194-38.4 38.399-38.4c21.209 0 38.4 17.195 38.4 38.4z\" fill=\"#231815\" p-id=\"2794\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/img.svg
// module id = HnV6
// module chunks = 54